module.exports = '<svg width="32" height="32" viewBox="0 0 32 32"><path d="M30 0H2C.894 0 0 .894 0 2v28c0 1.106.894 2 2 2h28c1.106 0 2-.894 2-2V2c0-1.106-.894-2-2-2zm-4 10a2 2 0 1 1-4 0h-4v12h2a2 2 0 1 1 0 4h-8a2 2 0 1 1 0-4h2V10h-4a2 2 0 1 1-4 0V8a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v2z"/></svg>'


//////////////////
// WEBPACK FOOTER
// ./~/li-icons/dist/js/text-1.js
// module id = 1448
// module chunks = 14